function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.479 1.19a.643.643 0 00-1.035.731l-6.69 6.69a2.57 2.57 0 103.635 3.636l6.69-6.69a.643.643 0 00.732-1.035L9.48 1.189zm-.455 1.363l2.424 2.423-1.315 1.315-4.488-.36.804-.803.682.681a.321.321 0 00.454-.454l-.681-.681 2.12-2.122zM5.086 6.49l.681.681a.321.321 0 01-.454.455l-.681-.681.454-.455zM3.268 8.308l.682.682a.321.321 0 01-.454.454l-.682-.681.454-.455z",
  fill: "currentColor"
});

var SvgRotatedTube = function SvgRotatedTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgRotatedTube;